/**
 * What a live scene pass binds into a node of the Live scene tree: property values laid over the
 * node, by its live path. A sub-scene's nodes are shared by every instance of it, so a pass never
 * writes into a node (ADR-0060).
 */
export const NO_PATCHES = new Map();
/** `node` with `patch` laid over its properties, and `node` itself where there is no patch. */
export function patchedNode(node, patch) {
    return patch ? { ...node, properties: { ...node.properties, ...patch } } : node;
}
//# sourceMappingURL=nodePatch.js.map